<template>
  <section class="customer-header">
    <div v-if="caseStudy.header_image_url" @click.stop="headerFocused = !headerFocused">
      <div
        v-if="headerFocused && editable"
        @click.stop="deleteHeaderImage"
        class="controls d-flex align-items-center justify-content-center"
      >
        <b-icon icon="trash-fill" />
      </div>
      <img :class="{ pointer: editable }" :src="caseStudy.header_image_url" />
    </div>
    <div class="upload-wrapper" v-else>
      <UeDropzone
        v-if="editable"
        id="customer-header-dropzone"
        ref="fileUploader"
        class="d-flex align-items-center justify-content-center"
        :useCustomSlot="true"
        :includeStyling="false"
        :options="headerDropzoneOptions"
        @vdropzone-success="uploadSuccess"
      >
        <div class="img-placeholder">
          <b-icon icon="person-circle" />
        </div>
      </UeDropzone>
    </div>
  </section>
</template>
<script lang="ts">
import { useCaseStudyStore } from '@app/stores/CaseStudyStore'
import { getCsrfToken } from '@lib/csrf'

export default {
  data() {
    return {
      headerFocused: false,
    }
  },
  props: {
    caseStudy: {
      type: Object,
      required: true,
    },
    editable: { type: Boolean, required: false, default: false },
  },
  computed: {
    headerDropzoneOptions() {
      return {
        url: `/app/api/v2/case_studies/${this.caseStudy.id}/attach_header_image.json`,
        headers: { 'X-CSRF-Token': getCsrfToken() },
        disablePreviews: true,
        createImageThumbnails: false,
      }
    },
  },
  methods: {
    uploadSuccess(file, response) {
      useCaseStudyStore().upsertCaseStudy(response.case_study)
    },
    deleteHeaderImage() {
      useCaseStudyStore()
        .removeHeaderImage(this.caseStudy.id)
        .then((response) => {
          useCaseStudyStore().upsertCaseStudy(response.data.case_study)
        })
        .finally(() => {
          this.headerFocused = !this.headerFocused
        })
    },
  },
}
</script>

<style lang="sass" scoped>
.pointer
  cursor: pointer

.controls
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1)
  position: absolute
  background: white
  border-radius: 10px
  height: 45px
  width: 40px
  z-index: 10
  margin-top: 10px
  right: 35px
  border: 1px solid var(--border-color)
  cursor: pointer

.customer-header
  img
    border-radius: 24px
    object-fit: cover
    height: 365px
    width: 100%

.upload-wrapper
  height: 350px

#customer-header-dropzone
  cursor: pointer
  background: rgb(250,250,250)
  border: 1px dashed var(--border-color)
  width: 100%
  height: 100%
  border-radius: 8px

  .img-placeholder
    font-size: 180px
    svg
      fill: var(--border-color)

  .dz-success-mark .dz-error-mark
    display: none
  .dz-success-mark, .dz-error-mark
    display: none
  ::v-deep .dz-preview
    display: none
</style>
